(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["insta-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    var track = root.querySelector('[data-insta-track]');
    var dotsWrap = root.querySelector('[data-insta-dots]');
    var slider = root;
    var prev = root.closest('.ie-insta').querySelector('[data-insta-prev]');
    var next = root.closest('.ie-insta').querySelector('[data-insta-next]');
    if (!track) return;

    var timer = null;
    var pages = 1;

    function pageCount() {
      if (track.clientWidth === 0) return 1;
      return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth));
    }
    function currentPage() {
      if (track.clientWidth === 0) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function buildDots() {
      if (!dotsWrap) return;
      pages = pageCount();
      dotsWrap.innerHTML = '';
      if (pages < 2) return;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ie-insta__dot';
        b.setAttribute('aria-label', 'Seite ' + (i + 1));
        (function (idx) {
          b.addEventListener('click', function () { stopAuto(); goTo(idx); });
        })(i);
        dotsWrap.appendChild(b);
      }
      update();
    }
    function update() {
      var cur = currentPage();
      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === cur);
        }
      }
      if (prev) prev.disabled = cur <= 0;
      if (next) next.disabled = cur >= pages - 1;
    }

    if (prev) prev.addEventListener('click', function () { stopAuto(); goTo(Math.max(0, currentPage() - 1)); });
    if (next) next.addEventListener('click', function () { stopAuto(); goTo(Math.min(pages - 1, currentPage() + 1)); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', buildDots);

    function startAuto() {
      if (slider.getAttribute('data-autoplay') !== 'true') return;
      var speed = parseInt(slider.getAttribute('data-speed'), 10) || 5;
      stopAuto();
      timer = setInterval(function () {
        var cur = currentPage();
        goTo(cur >= pages - 1 ? 0 : cur + 1);
      }, speed * 1000);
    }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }

    slider.addEventListener('mouseenter', stopAuto);
    slider.addEventListener('touchstart', stopAuto, { passive: true });
    slider.addEventListener('mouseleave', startAuto);

    buildDots();
    startAuto();
    setTimeout(buildDots, 400);
  }

  /* Videos: stumm automatisch abspielen, Ton per Knopf, nur eines mit Ton. */
  function setupVideos() {
    var videos = document.querySelectorAll('.ie-insta__slide--video video');
    if (!videos.length) return;

    videos.forEach(function (v) {
      v.muted = true;
      v.loop = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });

    document.querySelectorAll('[data-insta-sound]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var slide = btn.closest('.ie-insta__slide--video');
        var video = slide ? slide.querySelector('video') : null;
        if (!video) return;
        var turnOn = video.muted;

        if (turnOn) {
          /* Erst alle anderen stummschalten, damit sich kein Ton überlagert. */
          document.querySelectorAll('.ie-insta__slide--video video').forEach(function (other) {
            if (other !== video) other.muted = true;
          });
          document.querySelectorAll('[data-insta-sound]').forEach(function (b) {
            if (b !== btn) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Ton einschalten'); }
          });
        }

        video.muted = !turnOn;
        btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
        btn.setAttribute('aria-label', turnOn ? 'Ton ausschalten' : 'Ton einschalten');
        var pr = video.play();
        if (pr && typeof pr.catch === 'function') pr.catch(function () {});
      });
    });

    /* Ausserhalb des Bildschirms pausieren, spart Akku und Daten. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var pr = v.play();
            if (pr && typeof pr.catch === 'function') pr.catch(function () {});
          } else {
            v.pause();
            if (!v.muted) {
              v.muted = true;
              var slide = v.closest('.ie-insta__slide--video');
              var btn = slide ? slide.querySelector('[data-insta-sound]') : null;
              if (btn) { btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Ton einschalten'); }
            }
          }
        });
      }, { threshold: 0.35 });
      videos.forEach(function (v) { io.observe(v); });
    }
  }

  function init() {
    document.querySelectorAll('[data-insta]').forEach(setup);
    setupVideos();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cart-form]');
  if (!root) return;

  var cartWrap = document.querySelector('.ie-cart');
  var moneyFormat = '{{amount}}';
  if (cartWrap) {
    try { var parsed = JSON.parse(cartWrap.getAttribute('data-money-format')); if (parsed) moneyFormat = parsed; } catch (e) {}
  }

  function formatMoney(cents) {
    var noDecimals = moneyFormat.indexOf('amount_no_decimals') !== -1;
    var useComma = moneyFormat.indexOf('comma_separator') !== -1;
    var value = (cents / 100).toFixed(noDecimals ? 0 : 2);
    if (useComma) value = value.replace('.', ',');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }
  function toast(msg) { document.dispatchEvent(new CustomEvent('ie:toast', { detail: { message: msg } })); }
  function setCount(n) { document.dispatchEvent(new CustomEvent('ie:cart-count', { detail: { count: n } })); }

  function getMax(input) {
    var raw = input.getAttribute('data-max-qty');
    if (raw === null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  /* Greys out the plus once the available stock for this line is reached. */
  function refreshStepper(itemEl) {
    var input = itemEl.querySelector('[data-cart-qty-input]');
    var incBtn = itemEl.querySelector('[data-cart-increase]');
    if (!input || !incBtn) return;
    var cur = parseInt(input.value, 10) || 0;
    var max = getMax(input);
    incBtn.disabled = (max !== null && cur >= max);
  }

  function showConfirm(itemEl) {
    var controls = itemEl.querySelector('[data-controls]');
    var confirmEl = itemEl.querySelector('[data-confirm]');
    if (controls) controls.hidden = true;
    if (confirmEl) confirmEl.hidden = false;
  }
  function hideConfirm(itemEl, restore) {
    var controls = itemEl.querySelector('[data-controls]');
    var confirmEl = itemEl.querySelector('[data-confirm]');
    var input = itemEl.querySelector('[data-cart-qty-input]');
    if (restore && input) input.value = input.getAttribute('data-last-value') || 1;
    if (controls) controls.hidden = false;
    if (confirmEl) confirmEl.hidden = true;
  }

  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (subtotalEl) subtotalEl.dataset.cents = '{{ cart.total_price }}';

  /* Set the initial disabled state of every plus button on load. */
  root.querySelectorAll('[data-cart-item]').forEach(function (el) { refreshStepper(el); });

  /* Optimistic UI: update line total + subtotal instantly; the server reconciles afterwards. */
  function optimistic(itemEl, newQty) {
    var unit = parseInt(itemEl.getAttribute('data-unit-price'), 10) || 0;
    var totalEl = itemEl.querySelector('[data-cart-item-total]');
    if (totalEl) totalEl.textContent = formatMoney(unit * newQty);

    var input = itemEl.querySelector('[data-cart-qty-input]');
    var prev = parseInt(input.getAttribute('data-last-value'), 10) || 0;
    if (subtotalEl && subtotalEl.dataset.cents) {
      var newCents = Math.max(0, parseInt(subtotalEl.dataset.cents, 10) + unit * (newQty - prev));
      subtotalEl.dataset.cents = newCents;
      subtotalEl.textContent = formatMoney(newCents);
    }
    input.value = newQty;
    refreshStepper(itemEl);
  }

  function reconcile(itemEl, requested) {
    var key = itemEl.getAttribute('data-line-key');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: requested })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart_change_failed'); return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (subtotalEl) { subtotalEl.dataset.cents = cart.total_price; subtotalEl.textContent = formatMoney(cart.total_price); }

        if (requested <= 0) { removeRow(itemEl, cart.item_count); return; }

        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (line) {
          var totalEl = itemEl.querySelector('[data-cart-item-total]');
          if (totalEl) totalEl.textContent = formatMoney(line.final_line_price);
          var input = itemEl.querySelector('[data-cart-qty-input]');
          if (input) {
            if (line.quantity < requested) {
              toast('Nur noch ' + line.quantity + ' Stück verfügbar, Menge angepasst.');
            }
            input.value = line.quantity;
            input.setAttribute('data-last-value', line.quantity);
            refreshStepper(itemEl);
          }
        }
      })
      .catch(function () { toast('Das hat leider nicht geklappt. Bitte lade die Seite neu.'); });
  }

  function removeRow(itemEl, itemCount) {
    itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
    requestAnimationFrame(function () {
      itemEl.style.transition = 'opacity .25s ease, max-height .35s ease, padding .35s ease, margin .35s ease';
      itemEl.style.opacity = '0';
      itemEl.style.maxHeight = '0px';
      itemEl.style.paddingTop = '0';
      itemEl.style.paddingBottom = '0';
      itemEl.style.overflow = 'hidden';
      itemEl.style.borderBottom = 'none';
    });
    setTimeout(function () {
      itemEl.remove();
      if (itemCount === 0) window.location.reload();
    }, 380);
  }

  root.addEventListener('click', function (e) {
    var itemEl = e.target.closest('[data-cart-item]');
    if (!itemEl) return;

    if (e.target.closest('[data-confirm-yes]')) {
      var yesInput = itemEl.querySelector('[data-cart-qty-input]');
      if (yesInput) yesInput.value = 0;
      reconcile(itemEl, 0);
      return;
    }
    if (e.target.closest('[data-confirm-no]')) { hideConfirm(itemEl, true); return; }
    if (e.target.closest('[data-cart-remove]')) { showConfirm(itemEl); return; }

    var input = itemEl.querySelector('[data-cart-qty-input]');
    if (!input) return;
    var cur = parseInt(input.value, 10) || 0;

    if (e.target.closest('[data-cart-increase]')) {
      var max = getMax(input);
      if (max !== null && cur >= max) {
        toast(max > 0 ? 'Nur noch ' + max + ' Stück verfügbar' : 'Dieses Produkt ist leider ausverkauft');
        return;
      }
      optimistic(itemEl, cur + 1);
      input.setAttribute('data-last-value', cur + 1);
      reconcile(itemEl, cur + 1);
    } else if (e.target.closest('[data-cart-decrease]')) {
      if (cur <= 1) { showConfirm(itemEl); return; }
      optimistic(itemEl, cur - 1);
      input.setAttribute('data-last-value', cur - 1);
      reconcile(itemEl, cur - 1);
    }
  });

  root.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cart-qty-input]')) return;
    var itemEl = e.target.closest('[data-cart-item]');
    var input = e.target;
    var v = parseInt(input.value, 10);

    if (isNaN(v) || v <= 0) { showConfirm(itemEl); return; }
    var max = getMax(input);
    if (max !== null && v > max) {
      v = Math.max(1, max);
      toast('Nur noch ' + max + ' Stück verfügbar, Menge angepasst.');
    }
    optimistic(itemEl, v);
    input.setAttribute('data-last-value', v);
    reconcile(itemEl, v);
  });

  /* ---- Geschenkverpackung an- und abwählen ---- */
  var gwEl = document.querySelector('[data-giftwrap]');
  if (gwEl) {
    var gwToggle = gwEl.querySelector('[data-giftwrap-toggle]');
    var gwSpinner = gwEl.querySelector('[data-giftwrap-spinner]');
    var gwTimer = null;

    function gwBusy(state) {
      if (gwToggle) gwToggle.disabled = state;
      if (gwSpinner) gwSpinner.hidden = !state;
      gwEl.classList.toggle('is-busy', state);
      clearTimeout(gwTimer);
      if (state) {
        /* Sicherheitsnetz: nie dauerhaft blockiert bleiben. */
        gwTimer = setTimeout(function () {
          gwBusy(false);
          toast('Die Verbindung hat zu lange gedauert. Bitte versuche es nochmals.');
        }, 10000);
      }
    }

    /* Liest die Fehlermeldung von Shopify, damit der Grund sichtbar wird. */
    function gwFail(response, fallbackChecked) {
      function done(msg) {
        gwToggle.checked = fallbackChecked;
        gwBusy(false);
        toast(msg);
      }
      if (!response || typeof response.json !== 'function') {
        return done('Das hat leider nicht geklappt. Bitte versuche es nochmals.');
      }
      response.json()
        .then(function (data) {
          done(data && data.description ? data.description : 'Die Geschenkverpackung ist gerade nicht verfügbar.');
        })
        .catch(function () { done('Das hat leider nicht geklappt. Bitte versuche es nochmals.'); });
    }

    function gwApplyCart(cart) {
      setCount(cart.item_count);
      if (subtotalEl) {
        subtotalEl.dataset.cents = cart.total_price;
        subtotalEl.textContent = formatMoney(cart.total_price);
      }
    }

    gwToggle.addEventListener('change', function () {
      var wanted = gwToggle.checked;
      gwBusy(true);

      if (wanted) {
        var variantId = parseInt(gwEl.getAttribute('data-variant-id'), 10);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) { gwFail(r, false); return null; }
            return r.json();
          })
          .then(function (res) {
            if (!res) return;
            var line = res.items ? res.items[0] : res;
            if (line && line.key) gwEl.setAttribute('data-line-key', line.key);
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                gwApplyCart(cart);
                gwBusy(false);
                toast('Geschenkverpackung hinzugefügt.');
              });
          })
          .catch(function () { gwFail(null, false); });
      } else {
        var key = gwEl.getAttribute('data-line-key');
        if (!key) { gwBusy(false); return; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) {
            if (!r.ok) { gwFail(r, true); return null; }
            return r.json();
          })
          .then(function (cart) {
            if (!cart) return;
            gwEl.setAttribute('data-line-key', '');
            gwApplyCart(cart);
            gwBusy(false);
            toast('Geschenkverpackung entfernt.');
          })
          .catch(function () { gwFail(null, true); });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var toggle = document.querySelector('[data-filter-toggle]');
  var panel = document.querySelector('[data-filter-panel]');
  var overlay = document.querySelector('[data-filter-overlay]');
  var closeBtn = document.querySelector('[data-filter-close]');
  if (!toggle || !panel) return;

  function isMobile() { return window.matchMedia('(max-width: 899px)').matches; }

  function open() {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
    document.body.classList.add('ie-no-scroll');
  }
  function close() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (overlay) { overlay.classList.remove('is-open'); setTimeout(function () { overlay.hidden = true; }, 300); }
    document.body.classList.remove('ie-no-scroll');
  }

  toggle.addEventListener('click', function () {
    if (!isMobile()) return;
    if (panel.classList.contains('is-open')) { close(); } else { open(); }
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
  });
})();

/* Custom rounded sort dropdown, driven by the native select so filters/URL stay intact. */
(function () {
  var select = document.getElementById('ie-sort-select');
  if (!select || !select.form) return;

  var wrap = document.createElement('div');
  wrap.className = 'ie-sortdd';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ie-sortdd__btn';
  btn.setAttribute('aria-haspopup', 'listbox');
  btn.setAttribute('aria-expanded', 'false');
  var label = document.createElement('span');
  label.textContent = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';
  btn.appendChild(label);
  btn.insertAdjacentHTML('beforeend', '<svg class="ie-sortdd__caret" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="6 9 12 15 18 9"/></svg>');

  var menu = document.createElement('ul');
  menu.className = 'ie-sortdd__menu';
  menu.setAttribute('role', 'listbox');
  menu.hidden = true;

  function closeMenu() { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open'); }
  function openMenu() { menu.hidden = false; btn.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open'); }

  Array.prototype.forEach.call(select.options, function (opt) {
    var li = document.createElement('li');
    li.className = 'ie-sortdd__opt';
    li.setAttribute('role', 'option');
    li.textContent = opt.text;
    if (opt.selected) li.setAttribute('aria-selected', 'true');
    li.addEventListener('click', function () {
      select.value = opt.value;
      label.textContent = opt.text;
      closeMenu();
      if (typeof select.form.requestSubmit === 'function') { select.form.requestSubmit(); } else { select.form.submit(); }
    });
    menu.appendChild(li);
  });

  btn.addEventListener('click', function (e) { e.stopPropagation(); if (menu.hidden) { openMenu(); } else { closeMenu(); } });
  menu.addEventListener('click', function (e) { e.stopPropagation(); });
  document.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  wrap.appendChild(btn);
  wrap.appendChild(menu);
  select.parentNode.insertBefore(wrap, select);
  select.classList.add('is-enhanced');
  select.setAttribute('tabindex', '-1');
  select.setAttribute('aria-hidden', 'true');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-gallery]');
  var form = document.querySelector('[data-product-form]');
  var dataEl = document.querySelector('script[data-product-json]');

  function toast(msg) { document.dispatchEvent(new CustomEvent('ie:toast', { detail: { message: msg } })); }

  /* ---- Accordion ---- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.ie-accordion__item');
      var open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---- Sicherheitshinweis ans Ende der Produktbeschreibung verschieben ---- */
  (function moveSafetyNote() {
    var desc = document.querySelector('.ie-product-page__desc');
    if (!desc || desc.querySelector('.ie-product-safety')) return;
    var markerRe = /^\s*(sicherheitshinweis|warnhinweis|warnhinweise|warnung|achtung|hinweis zur sicherheit)\b/i;
    var nodes = Array.prototype.slice.call(desc.children);
    var idx = -1;
    for (var i = 0; i < nodes.length; i++) {
      if (markerRe.test((nodes[i].textContent || '').trim())) { idx = i; break; }
    }
    if (idx === -1) return;

    var toMove = [nodes[idx]];
    // Ist der Treffer nur eine kurze Überschrift, den folgenden Absatz mitnehmen.
    if ((nodes[idx].textContent || '').trim().length < 40) {
      var next = nodes[idx + 1];
      if (next) {
        var tag = (next.tagName || '').toLowerCase();
        if (!/^h[1-6]$/.test(tag) && !markerRe.test((next.textContent || '').trim())) {
          toMove.push(next);
        }
      }
    }

    var wrap = document.createElement('div');
    wrap.className = 'ie-product-safety';
    toMove.forEach(function (el) { wrap.appendChild(el); });
    desc.appendChild(wrap);
  })();

  if (!form || !dataEl) return;
  var variants = JSON.parse(dataEl.textContent).variants;

  var qtyInput = form.querySelector('[data-qty-input]');
  function getMax() {
    if (!qtyInput) return null;
    var raw = qtyInput.getAttribute('data-max-qty');
    if (raw === null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  /* ---- Gallery ---- */
  if (root) {
    var slides = root.querySelectorAll('[data-gallery-slide]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    function showSlide(index) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === String(index)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-index') === String(index)); });
      dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-index') === String(index)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.getAttribute('data-index')); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { showSlide(d.getAttribute('data-index')); }); });
  }

  /* ---- Quantity stepper (with optimistic stock cap) ---- */
  var decBtn = form.querySelector('[data-qty-decrease]');
  var incBtn = form.querySelector('[data-qty-increase]');
  /* Greys out minus at 1 and plus once the available stock is reached. */
  function refreshStepper() {
    if (!qtyInput) return;
    var cur = parseInt(qtyInput.value, 10) || 1;
    var max = getMax();
    if (decBtn) decBtn.disabled = cur <= 1;
    if (incBtn) incBtn.disabled = (max !== null && cur >= max);
  }
  if (qtyInput && decBtn && incBtn) {
    decBtn.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      refreshStepper();
    });
    incBtn.addEventListener('click', function () {
      var cur = parseInt(qtyInput.value, 10) || 1;
      var max = getMax();
      if (max !== null && cur >= max) {
        toast(max > 0 ? 'Nur noch ' + max + ' Stück verfügbar' : 'Dieses Produkt ist leider ausverkauft');
        refreshStepper();
        return;
      }
      qtyInput.value = cur + 1;
      refreshStepper();
    });
    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      var max = getMax();
      if (isNaN(v) || v < 1) { qtyInput.value = 1; }
      else if (max !== null && v > max) {
        qtyInput.value = Math.max(1, max);
        toast('Nur noch ' + max + ' Stück verfügbar, Menge angepasst.');
      }
      refreshStepper();
    });
    refreshStepper();
  }

  /* ---- Variant picker (pills) ---- */
  var picker = form.querySelector('[data-variant-picker]');
  var variantIdInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add-btn]');
  var addBtnText = form.querySelector('[data-add-btn-text]');
  var priceCurrent = document.querySelector('[data-price-current]');
  var priceCompare = document.querySelector('[data-price-compare]');
  var saleBadge = document.querySelector('[data-sale-badge]');
  var priceWrap = document.querySelector('[data-price]');
  var saleActive = false, saleShowPrice = false, saleBadgeText = '';
  if (priceWrap) {
    saleActive = priceWrap.getAttribute('data-sale-active') === 'true';
    saleShowPrice = priceWrap.getAttribute('data-sale-showprice') === 'true';
    saleBadgeText = priceWrap.getAttribute('data-sale-badge-text') || '';
  }

  /* Hinweis bei knappem Bestand aktualisieren */
  var lowEl = document.querySelector('[data-lowstock]');
  function updateLowStock(max) {
    if (!lowEl) return;
    if (lowEl.getAttribute('data-enabled') !== 'true') { lowEl.hidden = true; return; }
    var limit = parseInt(lowEl.getAttribute('data-limit'), 10) || 5;
    var n = (max === null || typeof max === 'undefined') ? -1 : parseInt(max, 10);
    if (!isNaN(n) && n > 0 && n <= limit) {
      var txt = lowEl.querySelector('[data-lowstock-text]');
      if (txt) txt.textContent = 'Nur noch ' + n + ' verfügbar';
      lowEl.hidden = false;
    } else {
      lowEl.hidden = true;
    }
  }

  function applyVariantStock(variant) {
    updateLowStock(variant.max);
    if (!qtyInput) return;
    if (variant.max !== null && typeof variant.max !== 'undefined') {
      qtyInput.setAttribute('data-max-qty', variant.max);
      var cur = parseInt(qtyInput.value, 10) || 1;
      if (cur > variant.max) qtyInput.value = Math.max(1, variant.max);
    } else {
      qtyInput.removeAttribute('data-max-qty');
    }
    refreshStepper();
  }

  if (picker) {
    var selected = [];
    picker.querySelectorAll('.ie-variantpicker__group').forEach(function (group) {
      var sel = group.querySelector('.is-selected');
      selected.push(sel ? sel.getAttribute('data-value') : null);
    });

    function findVariant(options) {
      return variants.find(function (v) { return v.options.every(function (opt, i) { return opt === options[i]; }); });
    }
    function updateAvailability() {
      picker.querySelectorAll('.ie-variantpicker__pill').forEach(function (pill) {
        var idx = parseInt(pill.getAttribute('data-option-index'), 10);
        var testOptions = selected.slice();
        testOptions[idx] = pill.getAttribute('data-value');
        var match = findVariant(testOptions);
        var unavailable = !match || !match.available;
        pill.classList.toggle('is-unavailable', unavailable);
        pill.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      });
    }
    function selectVariant() {
      var variant = findVariant(selected);
      if (!variant) return;
      variantIdInput.value = variant.id;
      if (priceCurrent) {
        if (variant.comparePrice) {
          priceCurrent.textContent = variant.price;
          priceCurrent.classList.add('ie-product__price--sale');
        } else if (saleActive && saleShowPrice && variant.priceReduced) {
          priceCurrent.textContent = variant.priceReduced;
          priceCurrent.classList.add('ie-product__price--sale');
        } else {
          priceCurrent.textContent = variant.price;
          priceCurrent.classList.remove('ie-product__price--sale');
        }
      }
      if (priceCompare) {
        if (variant.comparePrice) {
          priceCompare.textContent = variant.comparePrice; priceCompare.hidden = false;
        } else if (saleActive && saleShowPrice) {
          priceCompare.textContent = variant.price; priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (saleBadge) {
        if (variant.comparePrice && variant.salePercent) {
          saleBadge.textContent = variant.salePercent + '% reduziert';
          saleBadge.hidden = false;
        } else if (saleActive) {
          saleBadge.textContent = saleBadgeText;
          saleBadge.hidden = false;
        } else {
          saleBadge.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      applyVariantStock(variant);
      if (variant.mediaPosition !== null && root) {
        var slide = root.querySelector('[data-gallery-slide][data-index="' + variant.mediaPosition + '"]');
        if (slide) {
          root.querySelectorAll('[data-gallery-slide]').forEach(function (s) { s.classList.remove('is-active'); });
          slide.classList.add('is-active');
          root.querySelectorAll('[data-gallery-thumb], [data-gallery-dot]').forEach(function (el) {
            el.classList.toggle('is-active', el.getAttribute('data-index') === String(variant.mediaPosition));
          });
        }
      }
      updateAvailability();
    }

    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('.ie-variantpicker__pill');
      if (!pill) return;
      if (pill.classList.contains('is-unavailable')) return;
      var idx = parseInt(pill.getAttribute('data-option-index'), 10);
      selected[idx] = pill.getAttribute('data-value');
      var grp = pill.closest('.ie-variantpicker__group');
      grp.querySelectorAll('.ie-variantpicker__pill').forEach(function (p) {
        p.classList.remove('is-selected'); p.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('is-selected');
      pill.setAttribute('aria-checked', 'true');
      var nameEl = grp.querySelector('[data-selected-name]');
      if (nameEl) nameEl.textContent = pill.getAttribute('data-value');
      selectVariant();
    });

    updateAvailability();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('.ie-carousel__arrow[data-dir="prev"]');
    var next = root.querySelector('.ie-carousel__arrow[data-dir="next"]');

    function amount() {
      var card = track.querySelector('.ie-carousel__card');
      if (!card) return track.clientWidth * 0.8;
      var gap = 26;
      // scroll by roughly two cards, but never more than the viewport
      return Math.min(track.clientWidth * 0.9, (card.offsetWidth + gap) * 2);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var overflow = track.scrollWidth > track.clientWidth + 4;
      var nav = root.querySelector('.ie-carousel__nav');
      if (nav) nav.style.display = overflow ? '' : 'none';
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initAll() { document.querySelectorAll('.ie-carousel').forEach(initCarousel); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
